
import React from "react";
import "./terms-conditions.css";
import Header, { Footer } from "../HomePage/header";

const TermsAndConditions = () => {
  return (
    <>
    <Header/>

    <div className="terms-container">
      <h1 className="terms-title">Terms and Conditions</h1>
      <p className="terms-intro">
        Welcome to Sulav Sewa. By using our services and purchasing products through our platform, you agree to the following terms and conditions. Please read them carefully.
      </p>

      <section className="terms-section">
        <h2>1. Services</h2>
        <p>
          • Sulav Sewa provides various services and products for your convenience. <br />
          • We strive to deliver quality services, but service availability may vary depending on your location and circumstances.
        </p>
      </section>

      <section className="terms-section">
        <h2>2. Product Information</h2>
        <p>
          • All products are described accurately on our platform. <br />
          • We reserve the right to modify product details, pricing, and availability without prior notice.
        </p>
      </section>

      <section className="terms-section">
        <h2>3. User Responsibilities</h2>
        <p>
          • Users must provide accurate information when using our services. <br />
          • Any misuse, fraud, or unlawful activity may result in suspension or termination of services.
        </p>
      </section>

      <section className="terms-section">
        <h2>4. Payments and Refunds</h2>
        <p>
          • Payments must be completed through the available payment methods. <br />
          • Refunds will be handled according to our refund policy and may vary depending on the product or service.
        </p>
      </section>

      <section className="terms-section">
        <h2>5. Liability</h2>
        <p>
          • Sulav Sewa is not responsible for any unexpected or extra problems that may happen from using our products or services. <br />
          • Use our services at your own discretion.
        </p>
      </section>

      <section className="terms-section">
        <h2>6. Our Responsibility</h2>
        <p>
          • We want you to have a smooth experience with Sulav Sewa. <br />
          • If anything goes wrong because of our mistake, don’t worry — we’ll take care of it. <br />
          • If you’re ever unhappy with our service, just reach out to us, and we’ll do our best to make it right. <br />
          • You can enjoy our services knowing we’ve got your back!
        </p>
      </section>

      <section className="terms-section">
        <h2>7. Changes to Terms</h2>
        <p>
          • We may update these terms from time to time. <br />
          • Continued use of our services constitutes acceptance of any changes.
        </p>
      </section>

      <p className="terms-footer">
        By using Sulav Sewa, you acknowledge that you have read and agree to these terms and conditions.
      </p>
    </div>
    <Footer/>
    </>
  );
};

export default TermsAndConditions;